module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"popup":{"title":"Do you have any changes to report?","description":"To stay compliant, you must report any changes in company information, key personnel, or employee details as they occur. Would you like to do that now?"}}}')
  delete Component.options._Ctor
}
